import { render, staticRenderFns } from "./SimulatorSheet-General.vue?vue&type=template&id=10064124&"
import script from "./SimulatorSheet-General.vue?vue&type=script&lang=js&"
export * from "./SimulatorSheet-General.vue?vue&type=script&lang=js&"
import style0 from "./SimulatorSheet-General.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports